import React from "react";
import Container from "../components/Layouts/Container";
import JobToronto from "../components/Jobs/JobToronto";

const JobTorontoPage = () => {
  return (
    <Container>
      <JobToronto />
    </Container>
  );
};

export default JobTorontoPage;
